<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-2 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">
          {{ "Import" }}
        </div>

        <div class="text-gray-800 text-xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="file"
              ref="myFiles"
              placeholder="File Name*"
              accept="application/JSON"
              @change="previewFiles"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div class="flex items-center my-4">
          <input
            v-model="deleteOldAnnotation"
            id="default-checkbox"
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
          />
          <label
            for="default-checkbox"
            class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >Delete Old Annotation</label
          >
        </div>

        <div class="w-full flex justify-end p-3 cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              id="submitBtn"
              :disabled="files.length == 0"
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('importBatch', files, deleteOldAnnotation)"
            >
              Import
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    exportData: Object,
  },

  components: {},

  data() {
    return {
      files: [],
      deleteOldAnnotation: false,
    };
  },

  created() {},

  methods: {
    previewFiles() {
      this.files = this.$refs.myFiles.files;
    },
  },
};
</script>

<style>
button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}

/* Multiple input styling */
.vue-input-tag-wrapper {
  border: none !important;
}

.input-tag {
  background-color: #e40046 !important;
  border-color: #e40046 !important;
  color: white !important;
  border-radius: 2px !important;
}

.vue-input-tag-wrapper .new-tag {
  font-size: 15px !important;
  line-height: 24px !important;
}

.remove {
  color: black !important;
}

/* END */
</style>
